import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  snackbars: [],
  navigationDrawerIsVisible: true,
  contextualDrawerIsVisible: false,
  contextualDrawerIsMini: false,
  pageFullyLoaded: false,
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
